import { z } from 'zod';

/////////////////////////////////////////
// PERSON MOBILE SCHEMA
/////////////////////////////////////////

export const PersonMobileSchema = z.object({
  personmobileId: z.number().int(),
  cityId: z.number().int(),
  personId: z.number().int(),
  mobileType: z.number().int(),
  mobileToken: z.string(),
  deviceId: z.string(),
})

export type PersonMobile = z.infer<typeof PersonMobileSchema>

export default PersonMobileSchema;
